import React from "react";
import { Input, Form, Button, Divider, Select, message, Modal, Row, Col, InputNumber } from "antd";
import styles from "../management.module.scss";
import { useTranslation } from "react-i18next";
import { CharacterVerify } from "../../../Utility/RegExp";
import { useCreateCustomerInf } from "../queries";

const { Option } = Select;

interface createInfoProps {
  CreateVisible: boolean;
  setCreateVisible: (arg: boolean) => void;
}

const CreateInfoModalF = React.memo(({ CreateVisible, setCreateVisible }: createInfoProps) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const { mutateAsync: createCustomerInfMutation, isLoading: createCustomerInfLoading } = useCreateCustomerInf();

  const createCustomerInf = async (values: any) => {
    createCustomerInfMutation({ values })
      .then(() => {
        setCreateVisible(false);
        form.resetFields();
        message.success(t("ISMS.Success"));
      })
      .catch(() => {
        message.error(t("ISMS.Fail"));
      });
  };

  //limite the input value to be mulitples of 30
  const aliveNumberChange = (value: number) => {
    let newValue = Math.round(value / 30) * 30;
    form.setFieldsValue({ period_alive: newValue });
  };

  return (
    <Modal
      title={t("ISMS.CreateCustomer")}
      visible={CreateVisible}
      className={`${styles.modal}`}
      onCancel={() => {
        setCreateVisible(false);
        form.resetFields();
      }}
      footer={[
        <Button
          key="Submit"
          loading={createCustomerInfLoading}
          onClick={() => {
            form.submit();
          }}
        >
          {t("ISMS.Submit")}
        </Button>,
      ]}
    >
      <Form layout="vertical" name="CreateInfo" onFinish={createCustomerInf} form={form}>
        <div className="formwrap">
          <Row gutter={24} justify="space-around">
            <Col xs={24} sm={24} md={24} lg={24} xl={10}>
              <h2>{t("ISMS.CompanyInfo")}</h2>
              <Divider className={styles.divider} />

              <Form.Item
                name={"company"}
                label={t("ISMS.Company")}
                rules={[{ required: true, message: "required!" }, CharacterVerify]}
              >
                <Input placeholder={t("ISMS.CompanyName")} maxLength={30} />
              </Form.Item>
              <Form.Item name={"contact"} label={t("ISMS.ContactPerson")} rules={[CharacterVerify]}>
                <Input placeholder={t("ISMS.Person Name")} maxLength={30} />
              </Form.Item>
              <Form.Item name={"mail"} rules={[{ type: "email", message: "Invalid!!" }]} label={t("ISMS.Email")}>
                <Input placeholder={t("ISMS.MailAddress")} maxLength={30} />
              </Form.Item>
              <Form.Item
                name={"phone"}
                label={t("ISMS.Phone")}
                rules={[{ type: "string", message: "Invalid!!", pattern: /^\d+$/ }]}
              >
                <Input placeholder={t("ISMS.Phone Number")} maxLength={30} />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24} lg={24} xl={10}>
              <h2>{t("ISMS.Scheme")}</h2>
              <Divider className={styles.divider} />
              {/* <Form.Item
                  label="User"
                  name="user"
                  rules={[{ required: true, message: "Required!!" }]}
                >
                  <Input placeholder={'Available Users Number'}/>
                </Form.Item>
                <Form.Item
                  label="Group"
                  name="group"
                  rules={[{ required: true, message: "Required!!" }]}
                >
                  <Input placeholder={'Available Groups Number'}/>
                </Form.Item>
                <Form.Item
                  label="Device"
                  name="device"
                  rules={[{ required: true, message: "Required!!" }]}
                >
                  <Input placeholder={'Available Devices Number'}/>
                </Form.Item>
                <Form.Item
                  label="Expire"
                  name="expire"
                  rules={[{ required: true, message: "Required!!" }]}
                >
                  <Input placeholder="2020-12-12" />
                </Form.Item> */}

              <Form.Item
                label={t("ISMS.PeriodAlive(s)")}
                name="period_alive"
                rules={[{ required: true, message: "Required!!" }]}
                initialValue={30}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={30}
                  step={30}
                  max={86400}
                  placeholder={t("ISMS.AlivePeriodstepby30")}
                  onChange={aliveNumberChange}
                />
              </Form.Item>
              <Form.Item
                label={t("ISMS.StatusPeriod(s)")}
                name="period_status"
                rules={[{ required: true, message: "Required!!" }]}
                initialValue={30}
              >
                <InputNumber
                  placeholder={t("ISMS.StatusPeriod")}
                  min={30}
                  step={30}
                  max={86400}
                  style={{ width: "100%" }}
                />
              </Form.Item>
              <Form.Item
                label={t("ISMS.IoTPeriod(s)")}
                name="period_iot"
                rules={[{ required: true, message: "Required!!" }]}
                initialValue={30}
              >
                <InputNumber
                  placeholder={t("ISMS.IoTPeriod")}
                  min={30}
                  step={30}
                  max={86400}
                  style={{ width: "100%" }}
                />
              </Form.Item>
              <Form.Item
                label={t("ISMS.GPSPeriod(s)")}
                name="period_gps"
                rules={[{ required: true, message: "Required!!" }]}
                initialValue={30}
              >
                <InputNumber
                  placeholder={t("ISMS.GPSPeriod")}
                  min={30}
                  step={30}
                  max={86400}
                  style={{ width: "100%" }}
                />
              </Form.Item>
              <h2>{t("ISMS.Permission")}</h2>
              <Divider className={styles.divider} />
              <Form.Item
                label={t("ISMS.View Flow Data")}
                name="permission_viewFlowData"
                rules={[{ required: true, message: "Required!!" }]}
                initialValue={false}
              >
                <Select placeholder={"Enable/Disable"}>
                  {/* @ts-ignore */}
                  <Option value={true}> {t("ISMS.Enable")}</Option>
                  {/* @ts-ignore */}
                  <Option value={false}> {t("ISMS.Disable")}</Option>
                </Select>
              </Form.Item>
              {/* <Form.Item
                  style={{ display: "none" }}
                  label="alive_timeout"
                  name="alive_timeout"
                  rules={[{ required: true, message: "Required!!" }]}
                >
                  <Input />
                </Form.Item> */}
            </Col>
          </Row>
        </div>
      </Form>
    </Modal>
  );
});

export default CreateInfoModalF;
